/**
 * The two facts the get-the-app interstitial turns on, kept pure and
 * zero-import so the root `node --test` suites can execute them.
 *
 * An invite link opened in a PHONE'S BROWSER is a person without the app —
 * that is what the link landing in a browser means on a device the app runs
 * on. The web app is not built for that screen, so the answer is the landing
 * page and its download path, not a login wall in a viewport nothing here was
 * designed for. Desktop stays on the web flow: there is no app to send a
 * desktop to.
 */

/**
 * A phone or tablet browser. Modern iPadOS Safari reports itself as
 * Macintosh, so an iPad may fall through to the desktop flow — a tablet
 * viewport is the one place the web app is actually usable, so that miss is
 * acceptable rather than worth sniffing harder for.
 */
export function isMobileUserAgent(userAgent: string): boolean {
  return /Android|iPhone|iPad|iPod/i.test(userAgent);
}

/**
 * The landing page that belongs to this web-app host.
 *
 * Derived, not configured: the web app is served from `web.<domain>` in every
 * deployed environment (web.opncue.com, web.stg.opncue.com — see
 * `infra/opncue/web.tf`), and the landing page owns the apex of the same
 * domain. Stripping the `web.` prefix therefore keeps stg pointing at stg
 * without a second config key that could disagree with the hostname. Anything
 * else (localhost, a preview URL) gets production's landing page, which is
 * the only one whose download path will ever matter to a stranger.
 */
export function landingOriginForHost(host: string): string {
  return host.startsWith("web.")
    ? `https://${host.slice("web.".length)}`
    : "https://opncue.com";
}
